import { usePage } from '@inertiajs/vue3';
import getMixpanelService from '@/plugins/mixpanel';

const setDefaultData = (data) => {
  const baseData = data || {};

  const page = usePage();
  const context = page.props?.context;

  return {
    ...baseData,
    context: context.name ?? null,
  };
};

const analyticsProviders = [];

const analyticsService = {
  init: async (analyticsConfig = {}) => {
    const mixpanelService = getMixpanelService(analyticsConfig.enabled)
    
    // init services
    await mixpanelService.init(analyticsConfig.mixpanel_token);
    // append to providers
    analyticsProviders.push(mixpanelService);
  },
  track: (eventName, properties = {}) => {
    const eventData = setDefaultData(properties);

    analyticsProviders.forEach((provider) => {
      if (provider.getSubscribedEvents().includes(eventName)) {
        try {
          provider.track(eventName, eventData);
        } catch (error) {
          console.error(error);
        }
      }
    });
  },
};

export default {
  async install(app) {
    if (typeof window !== 'undefined') {
      try {
          app.config.globalProperties.$analytics = analyticsService;
        } catch (error) {
          console.warn('Could not access Inertia props:', error);
        }
    } else {
      console.log('Error')
    }
  }
}

